import { Action, ActionType } from "@redux/actionTypes/apiKSMActionType";
import { Reducer } from "react";

export interface IAPIKSMState {
  apiKSMDetailsByPID: IAPIKSMDetailsByPID[];
}

export interface IAPIKSMDetailsByPID {
  projectId: number;
  projectName: string;
  id?: number;
  country: string;
  briefNote: string;
  phasewiseDevelopmentBudget?: ITableData;
  apiDevelopmentSummary?: ITableData;
  apiDevelopmentData: ITableDataDev;
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  data: Record<string, any>[];
  total: Record<string, any>[];
}
export interface ITableDataDev {
  headers: Iheaders[];
  tableData: Record<string, any>[];
}

const initialState = {
  apiKSMDetailsByPID: [],
};

export const apiKSMReducer: Reducer<IAPIKSMState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.APIKSM_DETAILS_BY_PID:
      return {
        ...state,
        apiKSMDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
